import GenericApi from "./GenericApi";




export const AdmFilemanagerApi2 = {
  download: <T>(GenericApi:GenericApi<T>,orgId:number,fileId:number) : T => {
    return GenericApi.get("api/admin/bc/asset_files/org/" + orgId + "/filemanager2/download/" + fileId + "")
  },
}

export const FrontendDownloadBundleApi = {
  download: <T>(GenericApi:GenericApi<T>,token:string) : T => {
    return GenericApi.get("public-api/bc/asset_files/internal/frontend/download_bundle/download?token="+ ( token == null ? "" : token ) +"")
  },
}
export const FrontendFilesApi = {
  downloadFile: <T>(GenericApi:GenericApi<T>,organisationId:number,viewId:number,viewValue:string,assetId:number,fileId:number) : T => {
    return GenericApi.get("public-api/asset_frontend/bc/asset_files/" + organisationId + "/files/download?viewId="+ ( viewId == null ? "" : viewId ) +"&viewValue="+ ( viewValue == null ? "" : viewValue ) +"&assetId="+ ( assetId == null ? "" : assetId ) +"&fileId="+ ( fileId == null ? "" : fileId ) +"")
  },
}
